/**
 * Date formatting utilities
 */

/**
 * Format a completedAt timestamp to a relative or short date string.
 * Returns 'today', 'yesterday', 'N days ago', or 'MMM D' / 'MMM D, YYYY'.
 */
export function formatCompletedDate(completedAt: string): string {
  const d = new Date(completedAt);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return 'today';
  if (diffDays === 1) return 'yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: d.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
  });
}
